import lodash from 'lodash';

export const getTimezoneOffset = store => {
    const documents = lodash.get(store, 'documents');
    const currentDocument = lodash.find(documents, 'institutionTimezone');
    if (currentDocument) {
        return lodash.get(currentDocument, 'institutionTimezone');
    }

    const currentBinder = lodash.get(store, 'binder');
    if (currentBinder && currentBinder.institutionTimezone) {
        return lodash.get(currentBinder, 'institutionTimezone');
    }

    const institutionTimezone = lodash.get(store, 'me.institutionTimezone');
    if (institutionTimezone) {
        return institutionTimezone;
    }

    const defaultTimezone = lodash.get(store, 'me.defaultTimezone');
    return defaultTimezone;
};

export const binderInstitutionIdSelector = state => lodash.get(state, 'binder.layout.institutionId');
export const userDefaultInstitutionIdSelector = state => lodash.get(state, 'me.institution.id');

export const binderEmailDomainSelector = state => lodash.get(
    state,
    'application.config.emailManagementBinderDomain',
    'complionbinder.com'
);
